import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
  modal: {
    width: 400,
  },
})

export { useStyles }
